import React from "react";
import styles from "./Profile.module.sass";
import styles1 from "../Cards/Cards.module.sass";
import TextInput from "../../../../components/TextInput";
import cn from "classnames";
import { Card } from "../Cards";
import Empthy from "../../../../components/Empty";
import { useUser } from "../../../../context";
import customers from "../../../../i11/Customers";

const Profile = ({ item, card }) => {
	const { locale } = useUser();
	const data = card?.data.map((e) => e.card);

	return (
		<>
			<div className={styles.container}>
				<TextInput
					disabled
					value={item.firstName}
					className={styles.field}
					label={customers[locale].first_name}
				/>
				<TextInput
					disabled
					value={item.lastName}
					className={styles.field}
					label={customers[locale].last_name}
				/>
				<TextInput
					disabled
					value={item.email}
					className={styles.field}
					label={customers[locale].email}
				/>

				<TextInput
					disabled
					value={
						item?.identityStatus || customers[locale].not_verified
					}
					className={cn(styles.field)}
					label={customers[locale].kyc}
				/>
				<TextInput
					disabled
					value="0.00"
					className={styles.field}
					label={customers[locale].balance}
				/>
			</div>
			<div className="title-red">{customers[locale].cards}</div>
			{!card ? (
				<Empthy title={customers[locale].cards_disclaimer} />
			) : (
				<div className={styles1.container}>
					{data.map((e) => {
						return <Card data={e} key={e.id} />;
					})}
				</div>
			)}
		</>
	);
};

export default Profile;
